import dynamic from 'next/dynamic';

import { breakUpLongTask } from '@utils/breakUpLongTasks';

export const componentMap = {
	Accordions: dynamic(breakUpLongTask(() => import('@shared-components/components/Accordions'))),
	AgendaStepper: dynamic(breakUpLongTask(() => import('@shared-components/components/AgendaStepper'))),
	CategoryPicker: dynamic(
		breakUpLongTask(() => import('@shared-components/components/CategoryPicker/CategoryPicker'))
	),
	Columns: dynamic(breakUpLongTask(() => import('@shared-components/components/Columns'))),
	ConvertFlowQuiz: dynamic(breakUpLongTask(() => import('@shared-components/components/ConvertFlowQuiz'))),
	ConvertFlowCta: dynamic(breakUpLongTask(() => import('@shared-components/components/ConvertFlowCta'))),
	ContentTypeRichText: dynamic(breakUpLongTask(() => import('@shared-components/components/ContentTypeRichText'))),
	DisclaimerV2: dynamic(breakUpLongTask(() => import('@shared-components/components/Disclaimer'))),
	ExperimentContainer: dynamic(breakUpLongTask(() => import('@shared-components/components/ExperimentContainer'))),
	Footer: dynamic(breakUpLongTask(() => import('@shared-components/components/Footer'))),
	GoogleMapTemplate: dynamic(breakUpLongTask(() => import('@shared-components/components/GoogleMap'))),
	HalfScreen: dynamic(breakUpLongTask(() => import('@shared-components/components/HalfScreen'))),
	Header: dynamic(breakUpLongTask(() => import('@shared-components/components/Header'))),
	HeroV2: dynamic(breakUpLongTask(() => import('@shared-components/components/Hero'))),
	Iframe: dynamic(breakUpLongTask(() => import('@shared-components/components/Iframe'))),
	Insurance: dynamic(breakUpLongTask(() => import('@shared-components/components/Insurance'))),
	MeetOurStaff: dynamic(breakUpLongTask(() => import('@shared-components/components/MeetOurStaff/MeetOurStaff'))),
	MultiCardV2: dynamic(breakUpLongTask(() => import('@shared-components/components/MultiCard'))),
	PatientReviewsV2: dynamic(breakUpLongTask(() => import('@shared-components/components/PatientReviews'))),
	QuickLinks: dynamic(breakUpLongTask(() => import('@shared-components/components/QuickLinks/QuickLinks'))),
	Schema: dynamic(breakUpLongTask(() => import('@shared-components/components/Schema/Schema'))),
	Service: dynamic(breakUpLongTask(() => import('@shared-components/components/Service/Service'))),
	ServiceLineHero: dynamic(breakUpLongTask(() => import('@shared-components/components/ServiceLineHero'))),
	SegmentsContainer: dynamic(breakUpLongTask(() => import('@shared-components/components/SegmentsContainer'))),
	SingleMessage: dynamic(breakUpLongTask(() => import('@shared-components/components/SingleMessage'))),
	SmileAssessmentForm: dynamic(breakUpLongTask(() => import('@shared-components/components/SmileAssessmentForm'))),
	Spacer: dynamic(breakUpLongTask(() => import('@shared-components/components/Spacer'))),
	Table: dynamic(breakUpLongTask(() => import('@shared-components/components/Table'))),
	TermsAndConditions: dynamic(breakUpLongTask(() => import('@shared-components/components/TermsAndConditions'))),
	TextBlockSeo: dynamic(breakUpLongTask(() => import('@shared-components/components/TextBlockSEO'))),
	LinkForwarder: dynamic(breakUpLongTask(() => import('@shared-components/components/LinkForwarder/LinkForwarder'))),
	OdpHero: dynamic(breakUpLongTask(() => import('@shared-components/components/Hero/ODP/ODPHero'))),
	BlogDetailsPage: dynamic(breakUpLongTask(() => import('@shared-components/components/BlogDetailsPage'))),
	ProductFeature: dynamic(
		breakUpLongTask(() => import('@shared-components/components/ProductFeature/ProductFeature'))
	),
	BlogListPage: dynamic(breakUpLongTask(() => import('@shared-components/components/BlogListPage'))),
	BlogList: dynamic(breakUpLongTask(() => import('@shared-components/components/BlogList'))),
	StateLinks: dynamic(breakUpLongTask(() => import('@shared-components/components/Centers/StateLinks/StateLinks'))),
	CityLinks: dynamic(breakUpLongTask(() => import('@shared-components/components/Centers/CityLinks/CityLinks'))),
	VideoCarousel: dynamic(breakUpLongTask(() => import('@shared-components/components/VideoCarousel'))),
	Tabs: dynamic(breakUpLongTask(() => import('@shared-components/components/Tabs'))),
	Marquee: dynamic(breakUpLongTask(() => import('@shared-components/components/Marquee/Marquee'))),
	Quiz: dynamic(breakUpLongTask(() => import('@shared-components/components/Quiz/Quiz'))),
	ProductDisplay: dynamic(breakUpLongTask(() => import('@shared-components/components/ProductPricing'))),
	Banner: dynamic(breakUpLongTask(() => import('@shared-components/components/Banner/Banner'))),
	Teletriage: dynamic(breakUpLongTask(() => import('@shared-components/components/Teletriage'))),
	SchedulingWidget: dynamic(breakUpLongTask(() => import('@shared-components/components/SchedulingWidget'))),
};

export const getComponentMapByTheme = (_themeId: string, _variant: string) => {
	return componentMap;
};
